module.exports = __webpack_public_path__ + "img/toolbar-logo-new.png";